<template>
    <svg width="14" height="14" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            v-if="isActive"
            d="M5 20L15 10L25 20"
            :stroke="iconColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="round"
        />
        <path
            v-else
            d="M25 10L15 20L5 10"
            :stroke="iconColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    props: {
        iconColor: {
            type: String,
            default: 'iconColor'
        },
        isActive: Boolean
    }
};
</script>
